export const wrapperStyles = {
  alignSelf: 'center',
  width: '100%',
  overflow: 'hidden',
  overflowWrap: 'break-word',
};
